var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgQuickbooks = function SvgQuickbooks(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3594,
    cy: 10.875,
    r: 10,
    fill: "#2CA01C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0804 6.96855H13.6244C15.7276 6.96855 17.4325 8.71767 17.4325 10.8753C17.4325 13.0329 15.7276 14.782 13.6244 14.782H10.9027V4.28963C11.6839 4.28963 12.3171 4.93927 12.3171 5.74071V13.3309H13.6244C14.9443 13.3309 16.0181 12.2294 16.0181 10.8753C16.0181 9.52125 14.9443 8.41963 13.6244 8.41963H13.0804V6.96855ZM7.0943 14.7814C4.99113 14.7814 3.28619 13.0323 3.28619 10.8747C3.28619 8.71713 4.99113 6.96797 7.0943 6.96797H9.81602V17.4604C9.03486 17.4604 8.40159 16.8107 8.40159 16.0093V8.41905H7.0943C5.77443 8.41905 4.70063 9.52063 4.70063 10.8747C4.70063 12.2287 5.77443 13.3304 7.0943 13.3304H7.63831V14.7814H7.0943Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgQuickbooks);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "quickbooks.288a10a3ac2d8c01dcd6b6b6e7c89bd3.svg";